import { queryClient } from '../../../queryClient';
import { NUMERICS_API_URL } from '../../../constants';
import { GetNumberData } from 'api/number';
import { InputNumber, Select, Input } from 'antd';

export const ValueComparisonWidget = (props) => {
  const { value = { matching: null, num: null }, setValue } = props;
  const operatorOptions = [
    { value: 'all', label: 'All Matching' },
    { value: 'any', label: 'Any Matching' },
  ];
  return (
    <div style={{ display: 'flex', gap: '5px' }}>
      <Select value={value.matching} onChange={(matching) => setValue({ ...value, matching })}>
        {operatorOptions.map(({ value, label }) => (
          <Select.Option key={value + ''} value={value + ''}>
            {label}
          </Select.Option>
        ))}
      </Select>
      <InputNumber value={value.num} onChange={(num) => setValue({ ...value, num })} />
    </div>
  );
};

export const NumericValueWithUnitWidget = (props) => {
  const { value = { num: null, separator: null }, setValue, listValues = [] } = props;
  return (
    <div style={{ display: 'flex', gap: '5px' }}>
      <InputNumber value={value.num} onChange={(num) => setValue({ ...value, num })} />
      <Select value={value.separator} onChange={(separator) => setValue({ ...value, separator })}>
        {listValues.map(({ value, title }) => (
          <Select.Option key={value + ''} value={value + ''}>
            {title}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export const VitalLabMatcherWidget = (props) => {
  const numbers: GetNumberData[] | undefined = queryClient.getQueryData([NUMERICS_API_URL]);
  const options = (numbers || []).map((n) => ({ value: n.unique_code, label: n.title }));
  const { value = { uniqueCode: null }, setValue } = props;
  return (
    <Select value={value.uniqueCode} onChange={(uniqueCode) => setValue({ uniqueCode })}>
      {options.map(({ value, label }) => (
        <Select.Option key={value + ''} value={value + ''}>
          {label}
        </Select.Option>
      ))}
    </Select>
  );
};

export const MedicationNameParserWidget = (props) => {
  const { value = { matchOp: null, query: null }, setValue } = props;
  const operatorOptions = [
    { value: 'equals', label: 'equals' },
    { value: 'contains', label: 'contains' },
    { value: 'starts_with', label: 'starts with' },
    { value: 'ends_with', label: 'ends with' },
    { value: 'matches_regex', label: 'matches regex' },
    { value: 'not_equals', label: 'not equals' },
  ];
  return (
    <div style={{ display: 'flex', gap: '5px' }}>
      <Select value={value.matchOp} onChange={(matchOp) => setValue({ ...value, matchOp })}>
        {operatorOptions.map(({ value, label }) => (
          <Select.Option key={value + ''} value={value + ''}>
            {label}
          </Select.Option>
        ))}
      </Select>
      <Input
        type='text'
        value={value.query}
        onChange={(e) => setValue({ ...value, query: e.currentTarget.value })}
      />
    </div>
  );
};
